import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { LandingPage } from './GoogleAuth';
import Layout from './Layout/Layout';
import './Styles/App.css';
import './Styles/Tabulator.css';
import './Styles/Formatting.css';
import './Assets/Brightpick-Regular2.ttf';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { apolloLink } from './apolloInit';

// Configure Apollo Client cache with proper policies
const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                getProductionOrders: {
                    // Merge function to handle pagination if needed
                    merge(existing = [], incoming) {
                        return incoming;
                    }
                }
            }
        }
    }
});

// Combine auth link with HTTP link
export const apolloClient = new ApolloClient({
    link: apolloLink,
    cache,
    defaultOptions: {
        watchQuery: {
            // Don't refetch on window focus
            notifyOnNetworkStatusChange: false,
            // Use cache first, then network
            fetchPolicy: 'cache-first',
            // Error policy
            errorPolicy: 'all'
        },
        query: {
            // Use cache first, then network
            fetchPolicy: 'cache-first',
            errorPolicy: 'all'
        }
    }
});

function App(): JSX.Element {
    return (
        <ApolloProvider client={apolloClient}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LandingPage doLogout={false} />} />
                    <Route path="/logout" element={<LandingPage doLogout={true} />} />
                    <Route path="*" element={<Layout />} />
                </Routes>
            </BrowserRouter>
        </ApolloProvider>
    );
}

export default App;
